var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoolsideBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.822 3h1.542v4.941h-1.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8a2.5 2.5 0 012.5 2.5V21h0-5V10.5A2.5 2.5 0 0116.5 8z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18a2 2 0 002-2v-2.608h0-4V16a2 2 0 002 2z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.047 18v3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M16.988 21.024h4.782M2.234 17.04c.804-1.01 1.7-1.227 2.684-.653 1.478.862 2.393.924 3.7.132 1.308-.792 2.126-.485 2.99.52M2.234 20.04c.804-1.01 1.7-1.227 2.684-.653 1.478.862 2.393.924 3.7.132 1.308-.792 2.126-.485 2.99.52"
  })))));
}
export default SvgPoolsideBar;